import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import ScoreDetailsHeader from '../Components/Common/ScoreDetailsHeader';
import FactorsPanel from './Components/Factors/FactorsPanel';

function PersonalityScoreDetails(): React.JSX.Element {
    return (
        <div className="bg-card rounded-xl border p-5">
            <ScoreDetailsHeader description={UIStrings.PersonalityScoreDetailsHeader} />
            <FactorsPanel />
        </div>
    );
}

export default PersonalityScoreDetails;
